export const tasksWithDropImages = [
  "f7c5e6d2-3fcb-4f0c-875d-9e8a27b5ec5b",
  "b7e94c47-17c6-4e44-934b-4c0f71807e3a",
  "9f3c5b96-3e56-4ab1-9e37-96307a221ed9",
];
export const IMAGE_BOX_WIDTH = window.innerHeight < 720 ? "100px" : "127px";
export const IMAGE_BOX_HEIGHT = window.innerHeight < 720 ? "70px" : "100px";
export const IMAGE_WIDTH = window.innerHeight < 720 ? "100px" : "150px";
export const MAX_GRID_WIDTH = window.innerHeight < 821 ? "120px" : "200px";
export const DROP_IMAGE_WRAPPER_HEIGHT = window.innerHeight < 720 ? "170px" : "250px";
